/**
 * Pure decisions for the General settings panel: the popup-style label and the
 * enum validators that gate which modal-type / theme update is allowed. No
 * `vue`/`ref`/IO — the shell performs the `updateUserPreferences` write only
 * when the validator returns a value.
 */

export type ModalType = 'dialog' | 'drawer'
export type Theme = 'light' | 'dark' | 'auto'

/** Human-readable label for the current popup style. */
export function modalTypeLabel(modalType: ModalType): 'Drawer' | 'Dialog' {
  return modalType === 'drawer' ? 'Drawer' : 'Dialog'
}

/** Narrow an unknown radio value to a valid modal type, or `null`. */
export function parseModalType(value: unknown): ModalType | null {
  return value === 'dialog' || value === 'drawer' ? value : null
}

/** Narrow an unknown toggle value to a valid theme, or `null`. */
export function parseTheme(value: unknown): Theme | null {
  return value === 'light' || value === 'dark' || value === 'auto'
    ? value
    : null
}
